/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import '../../banking/account_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "models": {
            "nested": {
              "Account": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "primaryBankIdentificationNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "availableBalance": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "pendingBalance": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "totalBalance": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "withdrawalCountThisMonth": {
                    "type": "uint32",
                    "id": 8,
                    "rule": "optional"
                  },
                  "isPrimary": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.sfs.models.Account.Status",
                    "id": 10,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "category": {
                    "type": ".squareup.banking.SavingsAccountMetadata.Category",
                    "id": 12,
                    "rule": "optional"
                  },
                  "bankcBalanceId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "isLockedForFreeze": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "isLocked": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "ACCOUNT_STATUS_DO_NOT_USE": 0,
                      "OPEN": 1,
                      "CLOSED": 2,
                      "PENDING_OPEN": 3,
                      "PENDING_CLOSED": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.Account && !$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.Account?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc An SFS based Account
 * --
 *
 * SOURCE Account @ squareup/sfs/models/account.proto at 13:1
 */
export const Account = $root.lookupType('squareup.sfs.models.Account');
fixType(Account, {
  id: {
    required: true
  },
  customerId: {
    required: true
  },
  accountNumberSuffix: {
    notEmpty: true
  },
  primaryBankIdentificationNumber: {
    required: true
  },
  availableBalance: {
    required: true
  },
  pendingBalance: {
    required: true
  },
  totalBalance: {
    required: true
  },
  withdrawalCountThisMonth: {
    required: true
  },
  isPrimary: {
    required: true
  },
  status: {
    required: true
  },
  isLockedForFreeze: {
    required: true
  },
  isLocked: {
    required: true
  }
});
Builder.createAndAttachToType(Account);
/**
 * SOURCE Status @ squareup/sfs/models/account.proto at 14:3
 */
Account.Status = $root.lookupEnum('squareup.sfs.models.Account.Status').values;